import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Col } from 'antd';
import { connect } from "react-redux";
import { HeaderMemberProfile } from '../'

const { Sider } = Layout;

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showProgress: true,
            emptyData: false
        }
    }

    componentDidMount() {
        this.props.onRef(this)
        let id = this.props.match.params.ID;
        this.componentMemberHeader.retrieveData(id);
    };

    componentWillUnmount() {
        this.props.onRef(undefined)
    };

    emptyData = () => {
        this.setState({ showProgress: false, emptyData: true })
    };

    render() {
        const { memberid, permission, location } = this.props;
        let permissionList = permission.usermenu;
        let selectedTab = location.pathname.split('/', 4) ? [location.pathname.split('/')[4]] : ['personal-information'];
        return (
            <Col>
                <Sider width={200} style={{ background: '#fff' }} breakpoint="lg" collapsedWidth="0">
                    <HeaderMemberProfile ref={(e) => { this.componentMemberHeader = e }} {...this.props} memberid={memberid} />
                    <Menu mode="inline" defaultSelectedKeys={selectedTab} style={{ height: '100%', marginTop: '20px' }} onClick={this.showProgress} >
                        <Menu.Item key="transaction" className={_checkPermission(permissionList, 'PMBRMGT', 'PMBRMGT_ACCESS')}>
                            <Link to={"/member/form/" + memberid + "/transaction"}>Transaction</Link>
                        </Menu.Item>
                        <Menu.Item key="activity" className={_checkPermission(permissionList, 'PMBRMGT', 'PMBRMGT_ACCESS')}>
                            <Link to={"/member/form/" + memberid + "/activity"}>Activity</Link>
                        </Menu.Item>
                    </Menu >
                </Sider >
            </Col >
        )
    }
}

export function _checkPermission(permissionList, menucode, functioncode) {
    let result = '';
    if (permissionList[menucode] === undefined || (permissionList[menucode] && !permissionList[menucode][functioncode])) {
        result = "hidden";
    }
    return result;
}

const mapStateToProps = state => ({ ...state });
export default connect(mapStateToProps)(App);
